import React from 'react';
import AppsContainer from '@tenant/core/AppsContainer';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import DockerImageTable from './components/List/DockerImageTable';

const ListDockerImage = () => {
  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Library</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.DOCKER_IMAGE.LIST}>Docker Repositories</Link>
          </Typography>
        </Breadcrumbs>
      }
    >
      <Box
        sx={{
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        <DockerImageTable />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListDockerImage);
